export enum ActionPanelOrientation {
  BOTTOM = 'bottom',
  RIGHT = 'right',
}

export enum ActionPanelPosition {
  FIXED = 'fixed',
  STATIC = 'static',
}
